/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as EmptyPageRouteImport } from './pages/EmptyPage'
import { Route as IndexRouteImport } from './pages/index'
import { Route as SettingsIndexRouteImport } from './pages/settings/index'
import { Route as SchedulerIndexRouteImport } from './pages/scheduler/index'
import { Route as ProfileIndexRouteImport } from './pages/profile/index'
import { Route as PayrollIndexRouteImport } from './pages/payroll/index'
import { Route as OrganisationIndexRouteImport } from './pages/organisation/index'
import { Route as LiveMapIndexRouteImport } from './pages/live-map/index'
import { Route as InvoicesIndexRouteImport } from './pages/invoices/index'
import { Route as IncidentsIndexRouteImport } from './pages/incidents/index'
import { Route as EmployeesIndexRouteImport } from './pages/employees/index'
import { Route as DashboardIndexRouteImport } from './pages/dashboard/index'
import { Route as CoverageRequestsIndexRouteImport } from './pages/coverage-requests/index'
import { Route as ClientsIndexRouteImport } from './pages/clients/index'
import { Route as ChatIndexRouteImport } from './pages/chat/index'
import { Route as ActivityIndexRouteImport } from './pages/activity/index'
import { Route as AccessProfilesIndexRouteImport } from './pages/access-profiles/index'
import { Route as SettingsNotificationDefaultsRouteImport } from './pages/settings/notification-defaults'
import { Route as SettingsIncidentVisibilityRouteImport } from './pages/settings/incident-visibility'
import { Route as OnboardingCreateOrgRouteImport } from './pages/onboarding/create-org'
import { Route as InvoicesInvoiceIdRouteImport } from './pages/invoices/$invoiceId'
import { Route as IncidentsResolvedRouteImport } from './pages/incidents/resolved'
import { Route as IncidentsIncidentIdRouteImport } from './pages/incidents/$incidentId'
import { Route as ChatConversationIdRouteImport } from './pages/chat/$conversationId'
import { Route as authVerifyEmailRouteImport } from './pages/(auth)/verify-email'
import { Route as authSignupRouteImport } from './pages/(auth)/signup'
import { Route as authResetPasswordRouteImport } from './pages/(auth)/reset-password'
import { Route as authResendVerificationRouteImport } from './pages/(auth)/resend-verification'
import { Route as authLoginRouteImport } from './pages/(auth)/login'
import { Route as authForgotPasswordRouteImport } from './pages/(auth)/forgot-password'
import { Route as authCheckEmailRouteImport } from './pages/(auth)/check-email'
import { Route as ShiftsShiftIdIndexRouteImport } from './pages/shifts/$shiftId/index'
import { Route as SettingsEmploymentCategoriesIndexRouteImport } from './pages/settings/employment-categories/index'
import { Route as SettingsBillingIndexRouteImport } from './pages/settings/billing/index'
import { Route as SchedulerTimeOffIndexRouteImport } from './pages/scheduler/time-off/index'
import { Route as SchedulerTemplatesIndexRouteImport } from './pages/scheduler/templates/index'
import { Route as SchedulerSiteRosterIndexRouteImport } from './pages/scheduler/site-roster/index'
import { Route as SchedulerOvertimeIndexRouteImport } from './pages/scheduler/overtime/index'
import { Route as SchedulerOfficeTimeIndexRouteImport } from './pages/scheduler/office-time/index'
import { Route as SchedulerAttendanceIndexRouteImport } from './pages/scheduler/attendance/index'
import { Route as PatrolsPatrolIdIndexRouteImport } from './pages/patrols/$patrolId/index'
import { Route as ClientsClientIdIndexRouteImport } from './pages/clients/$clientId/index'
import { Route as ChatBroadcastsIndexRouteImport } from './pages/chat/broadcasts/index'
import { Route as AccessProfilesProfileIdIndexRouteImport } from './pages/access-profiles/$profileId/index'
import { Route as OnboardingSetupAccountIdRouteImport } from './pages/onboarding/setup/$accountId'
import { Route as InvitationsIdAcceptRouteImport } from './pages/invitations/$id/accept'
import { Route as EmployeesEmployeeIdProfileRouteImport } from './pages/employees/$employeeId/profile'
import { Route as ChatBroadcastsNewRouteImport } from './pages/chat/broadcasts/new'
import { Route as ChatBroadcastsBroadcastIdRouteImport } from './pages/chat/broadcasts/$broadcastId'
import { Route as PayrollRunsRunIdIndexRouteImport } from './pages/payroll/runs/$runId/index'
import { Route as DocumentsPayslipAccountIdRunIdRouteImport } from './pages/documents/payslip/$accountId/$runId'
import { Route as DocumentsInvoiceClientIdInvoiceIdRouteImport } from './pages/documents/invoice/$clientId/$invoiceId'
import { Route as ClientsClientIdSitesNewRouteImport } from './pages/clients/$clientId/sites/new'
import { Route as ClientsClientIdSitesSiteIdIndexRouteImport } from './pages/clients/$clientId/sites/$siteId/index'
import { Route as ClientsClientIdSitesSiteIdMemoBookRouteImport } from './pages/clients/$clientId/sites/$siteId/memo-book'
import { Route as PayrollRunsRunIdEmployeesUserIdIndexRouteImport } from './pages/payroll/runs/$runId/employees/$userId/index'

const EmptyPageRoute = EmptyPageRouteImport.update({
  id: '/EmptyPage',
  path: '/EmptyPage',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulerIndexRoute = SchedulerIndexRouteImport.update({
  id: '/scheduler/',
  path: '/scheduler/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const PayrollIndexRoute = PayrollIndexRouteImport.update({
  id: '/payroll/',
  path: '/payroll/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationIndexRoute = OrganisationIndexRouteImport.update({
  id: '/organisation/',
  path: '/organisation/',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveMapIndexRoute = LiveMapIndexRouteImport.update({
  id: '/live-map/',
  path: '/live-map/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => rootRouteImport,
} as any)
const IncidentsIndexRoute = IncidentsIndexRouteImport.update({
  id: '/incidents/',
  path: '/incidents/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesIndexRoute = EmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const CoverageRequestsIndexRoute = CoverageRequestsIndexRouteImport.update({
  id: '/coverage-requests/',
  path: '/coverage-requests/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityIndexRoute = ActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessProfilesIndexRoute = AccessProfilesIndexRouteImport.update({
  id: '/access-profiles/',
  path: '/access-profiles/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationDefaultsRoute =
  SettingsNotificationDefaultsRouteImport.update({
    id: '/settings/notification-defaults',
    path: '/settings/notification-defaults',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsIncidentVisibilityRoute =
  SettingsIncidentVisibilityRouteImport.update({
    id: '/settings/incident-visibility',
    path: '/settings/incident-visibility',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingCreateOrgRoute = OnboardingCreateOrgRouteImport.update({
  id: '/onboarding/create-org',
  path: '/onboarding/create-org',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesInvoiceIdRoute = InvoicesInvoiceIdRouteImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => rootRouteImport,
} as any)
const IncidentsResolvedRoute = IncidentsResolvedRouteImport.update({
  id: '/incidents/resolved',
  path: '/incidents/resolved',
  getParentRoute: () => rootRouteImport,
} as any)
const IncidentsIncidentIdRoute = IncidentsIncidentIdRouteImport.update({
  id: '/incidents/$incidentId',
  path: '/incidents/$incidentId',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatConversationIdRoute = ChatConversationIdRouteImport.update({
  id: '/chat/$conversationId',
  path: '/chat/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/(auth)/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignupRoute = authSignupRouteImport.update({
  id: '/(auth)/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authResendVerificationRoute = authResendVerificationRouteImport.update({
  id: '/(auth)/resend-verification',
  path: '/resend-verification',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authCheckEmailRoute = authCheckEmailRouteImport.update({
  id: '/(auth)/check-email',
  path: '/check-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ShiftsShiftIdIndexRoute = ShiftsShiftIdIndexRouteImport.update({
  id: '/shifts/$shiftId/',
  path: '/shifts/$shiftId/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsEmploymentCategoriesIndexRoute =
  SettingsEmploymentCategoriesIndexRouteImport.update({
    id: '/settings/employment-categories/',
    path: '/settings/employment-categories/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsBillingIndexRoute = SettingsBillingIndexRouteImport.update({
  id: '/settings/billing/',
  path: '/settings/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulerTimeOffIndexRoute = SchedulerTimeOffIndexRouteImport.update({
  id: '/scheduler/time-off/',
  path: '/scheduler/time-off/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulerTemplatesIndexRoute = SchedulerTemplatesIndexRouteImport.update({
  id: '/scheduler/templates/',
  path: '/scheduler/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulerSiteRosterIndexRoute =
  SchedulerSiteRosterIndexRouteImport.update({
    id: '/scheduler/site-roster/',
    path: '/scheduler/site-roster/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SchedulerOvertimeIndexRoute = SchedulerOvertimeIndexRouteImport.update({
  id: '/scheduler/overtime/',
  path: '/scheduler/overtime/',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulerOfficeTimeIndexRoute =
  SchedulerOfficeTimeIndexRouteImport.update({
    id: '/scheduler/office-time/',
    path: '/scheduler/office-time/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SchedulerAttendanceIndexRoute =
  SchedulerAttendanceIndexRouteImport.update({
    id: '/scheduler/attendance/',
    path: '/scheduler/attendance/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PatrolsPatrolIdIndexRoute = PatrolsPatrolIdIndexRouteImport.update({
  id: '/patrols/$patrolId/',
  path: '/patrols/$patrolId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsClientIdIndexRoute = ClientsClientIdIndexRouteImport.update({
  id: '/clients/$clientId/',
  path: '/clients/$clientId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatBroadcastsIndexRoute = ChatBroadcastsIndexRouteImport.update({
  id: '/chat/broadcasts/',
  path: '/chat/broadcasts/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessProfilesProfileIdIndexRoute =
  AccessProfilesProfileIdIndexRouteImport.update({
    id: '/access-profiles/$profileId/',
    path: '/access-profiles/$profileId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingSetupAccountIdRoute =
  OnboardingSetupAccountIdRouteImport.update({
    id: '/onboarding/setup/$accountId',
    path: '/onboarding/setup/$accountId',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvitationsIdAcceptRoute = InvitationsIdAcceptRouteImport.update({
  id: '/invitations/$id/accept',
  path: '/invitations/$id/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesEmployeeIdProfileRoute =
  EmployeesEmployeeIdProfileRouteImport.update({
    id: '/employees/$employeeId/profile',
    path: '/employees/$employeeId/profile',
    getParentRoute: () => rootRouteImport,
  } as any)
const ChatBroadcastsNewRoute = ChatBroadcastsNewRouteImport.update({
  id: '/chat/broadcasts/new',
  path: '/chat/broadcasts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatBroadcastsBroadcastIdRoute =
  ChatBroadcastsBroadcastIdRouteImport.update({
    id: '/chat/broadcasts/$broadcastId',
    path: '/chat/broadcasts/$broadcastId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PayrollRunsRunIdIndexRoute = PayrollRunsRunIdIndexRouteImport.update({
  id: '/payroll/runs/$runId/',
  path: '/payroll/runs/$runId/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsPayslipAccountIdRunIdRoute =
  DocumentsPayslipAccountIdRunIdRouteImport.update({
    id: '/documents/payslip/$accountId/$runId',
    path: '/documents/payslip/$accountId/$runId',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsInvoiceClientIdInvoiceIdRoute =
  DocumentsInvoiceClientIdInvoiceIdRouteImport.update({
    id: '/documents/invoice/$clientId/$invoiceId',
    path: '/documents/invoice/$clientId/$invoiceId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClientsClientIdSitesNewRoute = ClientsClientIdSitesNewRouteImport.update({
  id: '/clients/$clientId/sites/new',
  path: '/clients/$clientId/sites/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsClientIdSitesSiteIdIndexRoute =
  ClientsClientIdSitesSiteIdIndexRouteImport.update({
    id: '/clients/$clientId/sites/$siteId/',
    path: '/clients/$clientId/sites/$siteId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClientsClientIdSitesSiteIdMemoBookRoute =
  ClientsClientIdSitesSiteIdMemoBookRouteImport.update({
    id: '/clients/$clientId/sites/$siteId/memo-book',
    path: '/clients/$clientId/sites/$siteId/memo-book',
    getParentRoute: () => rootRouteImport,
  } as any)
const PayrollRunsRunIdEmployeesUserIdIndexRoute =
  PayrollRunsRunIdEmployeesUserIdIndexRouteImport.update({
    id: '/payroll/runs/$runId/employees/$userId/',
    path: '/payroll/runs/$runId/employees/$userId/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/EmptyPage': typeof EmptyPageRoute
  '/check-email': typeof authCheckEmailRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/resend-verification': typeof authResendVerificationRoute
  '/reset-password': typeof authResetPasswordRoute
  '/signup': typeof authSignupRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/chat/$conversationId': typeof ChatConversationIdRoute
  '/incidents/$incidentId': typeof IncidentsIncidentIdRoute
  '/incidents/resolved': typeof IncidentsResolvedRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/onboarding/create-org': typeof OnboardingCreateOrgRoute
  '/settings/incident-visibility': typeof SettingsIncidentVisibilityRoute
  '/settings/notification-defaults': typeof SettingsNotificationDefaultsRoute
  '/access-profiles': typeof AccessProfilesIndexRoute
  '/activity': typeof ActivityIndexRoute
  '/chat': typeof ChatIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/coverage-requests': typeof CoverageRequestsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/employees': typeof EmployeesIndexRoute
  '/incidents': typeof IncidentsIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/live-map': typeof LiveMapIndexRoute
  '/organisation': typeof OrganisationIndexRoute
  '/payroll': typeof PayrollIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/scheduler': typeof SchedulerIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/chat/broadcasts/$broadcastId': typeof ChatBroadcastsBroadcastIdRoute
  '/chat/broadcasts/new': typeof ChatBroadcastsNewRoute
  '/employees/$employeeId/profile': typeof EmployeesEmployeeIdProfileRoute
  '/invitations/$id/accept': typeof InvitationsIdAcceptRoute
  '/onboarding/setup/$accountId': typeof OnboardingSetupAccountIdRoute
  '/access-profiles/$profileId': typeof AccessProfilesProfileIdIndexRoute
  '/chat/broadcasts': typeof ChatBroadcastsIndexRoute
  '/clients/$clientId': typeof ClientsClientIdIndexRoute
  '/patrols/$patrolId': typeof PatrolsPatrolIdIndexRoute
  '/scheduler/attendance': typeof SchedulerAttendanceIndexRoute
  '/scheduler/office-time': typeof SchedulerOfficeTimeIndexRoute
  '/scheduler/overtime': typeof SchedulerOvertimeIndexRoute
  '/scheduler/site-roster': typeof SchedulerSiteRosterIndexRoute
  '/scheduler/templates': typeof SchedulerTemplatesIndexRoute
  '/scheduler/time-off': typeof SchedulerTimeOffIndexRoute
  '/settings/billing': typeof SettingsBillingIndexRoute
  '/settings/employment-categories': typeof SettingsEmploymentCategoriesIndexRoute
  '/shifts/$shiftId': typeof ShiftsShiftIdIndexRoute
  '/clients/$clientId/sites/new': typeof ClientsClientIdSitesNewRoute
  '/documents/invoice/$clientId/$invoiceId': typeof DocumentsInvoiceClientIdInvoiceIdRoute
  '/documents/payslip/$accountId/$runId': typeof DocumentsPayslipAccountIdRunIdRoute
  '/payroll/runs/$runId': typeof PayrollRunsRunIdIndexRoute
  '/clients/$clientId/sites/$siteId/memo-book': typeof ClientsClientIdSitesSiteIdMemoBookRoute
  '/clients/$clientId/sites/$siteId': typeof ClientsClientIdSitesSiteIdIndexRoute
  '/payroll/runs/$runId/employees/$userId': typeof PayrollRunsRunIdEmployeesUserIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/EmptyPage': typeof EmptyPageRoute
  '/check-email': typeof authCheckEmailRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/resend-verification': typeof authResendVerificationRoute
  '/reset-password': typeof authResetPasswordRoute
  '/signup': typeof authSignupRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/chat/$conversationId': typeof ChatConversationIdRoute
  '/incidents/$incidentId': typeof IncidentsIncidentIdRoute
  '/incidents/resolved': typeof IncidentsResolvedRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/onboarding/create-org': typeof OnboardingCreateOrgRoute
  '/settings/incident-visibility': typeof SettingsIncidentVisibilityRoute
  '/settings/notification-defaults': typeof SettingsNotificationDefaultsRoute
  '/access-profiles': typeof AccessProfilesIndexRoute
  '/activity': typeof ActivityIndexRoute
  '/chat': typeof ChatIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/coverage-requests': typeof CoverageRequestsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/employees': typeof EmployeesIndexRoute
  '/incidents': typeof IncidentsIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/live-map': typeof LiveMapIndexRoute
  '/organisation': typeof OrganisationIndexRoute
  '/payroll': typeof PayrollIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/scheduler': typeof SchedulerIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/chat/broadcasts/$broadcastId': typeof ChatBroadcastsBroadcastIdRoute
  '/chat/broadcasts/new': typeof ChatBroadcastsNewRoute
  '/employees/$employeeId/profile': typeof EmployeesEmployeeIdProfileRoute
  '/invitations/$id/accept': typeof InvitationsIdAcceptRoute
  '/onboarding/setup/$accountId': typeof OnboardingSetupAccountIdRoute
  '/access-profiles/$profileId': typeof AccessProfilesProfileIdIndexRoute
  '/chat/broadcasts': typeof ChatBroadcastsIndexRoute
  '/clients/$clientId': typeof ClientsClientIdIndexRoute
  '/patrols/$patrolId': typeof PatrolsPatrolIdIndexRoute
  '/scheduler/attendance': typeof SchedulerAttendanceIndexRoute
  '/scheduler/office-time': typeof SchedulerOfficeTimeIndexRoute
  '/scheduler/overtime': typeof SchedulerOvertimeIndexRoute
  '/scheduler/site-roster': typeof SchedulerSiteRosterIndexRoute
  '/scheduler/templates': typeof SchedulerTemplatesIndexRoute
  '/scheduler/time-off': typeof SchedulerTimeOffIndexRoute
  '/settings/billing': typeof SettingsBillingIndexRoute
  '/settings/employment-categories': typeof SettingsEmploymentCategoriesIndexRoute
  '/shifts/$shiftId': typeof ShiftsShiftIdIndexRoute
  '/clients/$clientId/sites/new': typeof ClientsClientIdSitesNewRoute
  '/documents/invoice/$clientId/$invoiceId': typeof DocumentsInvoiceClientIdInvoiceIdRoute
  '/documents/payslip/$accountId/$runId': typeof DocumentsPayslipAccountIdRunIdRoute
  '/payroll/runs/$runId': typeof PayrollRunsRunIdIndexRoute
  '/clients/$clientId/sites/$siteId/memo-book': typeof ClientsClientIdSitesSiteIdMemoBookRoute
  '/clients/$clientId/sites/$siteId': typeof ClientsClientIdSitesSiteIdIndexRoute
  '/payroll/runs/$runId/employees/$userId': typeof PayrollRunsRunIdEmployeesUserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/EmptyPage': typeof EmptyPageRoute
  '/(auth)/check-email': typeof authCheckEmailRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/resend-verification': typeof authResendVerificationRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/signup': typeof authSignupRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/chat/$conversationId': typeof ChatConversationIdRoute
  '/incidents/$incidentId': typeof IncidentsIncidentIdRoute
  '/incidents/resolved': typeof IncidentsResolvedRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/onboarding/create-org': typeof OnboardingCreateOrgRoute
  '/settings/incident-visibility': typeof SettingsIncidentVisibilityRoute
  '/settings/notification-defaults': typeof SettingsNotificationDefaultsRoute
  '/access-profiles/': typeof AccessProfilesIndexRoute
  '/activity/': typeof ActivityIndexRoute
  '/chat/': typeof ChatIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/coverage-requests/': typeof CoverageRequestsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/employees/': typeof EmployeesIndexRoute
  '/incidents/': typeof IncidentsIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/live-map/': typeof LiveMapIndexRoute
  '/organisation/': typeof OrganisationIndexRoute
  '/payroll/': typeof PayrollIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/scheduler/': typeof SchedulerIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/chat/broadcasts/$broadcastId': typeof ChatBroadcastsBroadcastIdRoute
  '/chat/broadcasts/new': typeof ChatBroadcastsNewRoute
  '/employees/$employeeId/profile': typeof EmployeesEmployeeIdProfileRoute
  '/invitations/$id/accept': typeof InvitationsIdAcceptRoute
  '/onboarding/setup/$accountId': typeof OnboardingSetupAccountIdRoute
  '/access-profiles/$profileId/': typeof AccessProfilesProfileIdIndexRoute
  '/chat/broadcasts/': typeof ChatBroadcastsIndexRoute
  '/clients/$clientId/': typeof ClientsClientIdIndexRoute
  '/patrols/$patrolId/': typeof PatrolsPatrolIdIndexRoute
  '/scheduler/attendance/': typeof SchedulerAttendanceIndexRoute
  '/scheduler/office-time/': typeof SchedulerOfficeTimeIndexRoute
  '/scheduler/overtime/': typeof SchedulerOvertimeIndexRoute
  '/scheduler/site-roster/': typeof SchedulerSiteRosterIndexRoute
  '/scheduler/templates/': typeof SchedulerTemplatesIndexRoute
  '/scheduler/time-off/': typeof SchedulerTimeOffIndexRoute
  '/settings/billing/': typeof SettingsBillingIndexRoute
  '/settings/employment-categories/': typeof SettingsEmploymentCategoriesIndexRoute
  '/shifts/$shiftId/': typeof ShiftsShiftIdIndexRoute
  '/clients/$clientId/sites/new': typeof ClientsClientIdSitesNewRoute
  '/documents/invoice/$clientId/$invoiceId': typeof DocumentsInvoiceClientIdInvoiceIdRoute
  '/documents/payslip/$accountId/$runId': typeof DocumentsPayslipAccountIdRunIdRoute
  '/payroll/runs/$runId/': typeof PayrollRunsRunIdIndexRoute
  '/clients/$clientId/sites/$siteId/memo-book': typeof ClientsClientIdSitesSiteIdMemoBookRoute
  '/clients/$clientId/sites/$siteId/': typeof ClientsClientIdSitesSiteIdIndexRoute
  '/payroll/runs/$runId/employees/$userId/': typeof PayrollRunsRunIdEmployeesUserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/EmptyPage'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/resend-verification'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/chat/$conversationId'
    | '/incidents/$incidentId'
    | '/incidents/resolved'
    | '/invoices/$invoiceId'
    | '/onboarding/create-org'
    | '/settings/incident-visibility'
    | '/settings/notification-defaults'
    | '/access-profiles'
    | '/activity'
    | '/chat'
    | '/clients'
    | '/coverage-requests'
    | '/dashboard'
    | '/employees'
    | '/incidents'
    | '/invoices'
    | '/live-map'
    | '/organisation'
    | '/payroll'
    | '/profile'
    | '/scheduler'
    | '/settings'
    | '/chat/broadcasts/$broadcastId'
    | '/chat/broadcasts/new'
    | '/employees/$employeeId/profile'
    | '/invitations/$id/accept'
    | '/onboarding/setup/$accountId'
    | '/access-profiles/$profileId'
    | '/chat/broadcasts'
    | '/clients/$clientId'
    | '/patrols/$patrolId'
    | '/scheduler/attendance'
    | '/scheduler/office-time'
    | '/scheduler/overtime'
    | '/scheduler/site-roster'
    | '/scheduler/templates'
    | '/scheduler/time-off'
    | '/settings/billing'
    | '/settings/employment-categories'
    | '/shifts/$shiftId'
    | '/clients/$clientId/sites/new'
    | '/documents/invoice/$clientId/$invoiceId'
    | '/documents/payslip/$accountId/$runId'
    | '/payroll/runs/$runId'
    | '/clients/$clientId/sites/$siteId/memo-book'
    | '/clients/$clientId/sites/$siteId'
    | '/payroll/runs/$runId/employees/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/EmptyPage'
    | '/check-email'
    | '/forgot-password'
    | '/login'
    | '/resend-verification'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/chat/$conversationId'
    | '/incidents/$incidentId'
    | '/incidents/resolved'
    | '/invoices/$invoiceId'
    | '/onboarding/create-org'
    | '/settings/incident-visibility'
    | '/settings/notification-defaults'
    | '/access-profiles'
    | '/activity'
    | '/chat'
    | '/clients'
    | '/coverage-requests'
    | '/dashboard'
    | '/employees'
    | '/incidents'
    | '/invoices'
    | '/live-map'
    | '/organisation'
    | '/payroll'
    | '/profile'
    | '/scheduler'
    | '/settings'
    | '/chat/broadcasts/$broadcastId'
    | '/chat/broadcasts/new'
    | '/employees/$employeeId/profile'
    | '/invitations/$id/accept'
    | '/onboarding/setup/$accountId'
    | '/access-profiles/$profileId'
    | '/chat/broadcasts'
    | '/clients/$clientId'
    | '/patrols/$patrolId'
    | '/scheduler/attendance'
    | '/scheduler/office-time'
    | '/scheduler/overtime'
    | '/scheduler/site-roster'
    | '/scheduler/templates'
    | '/scheduler/time-off'
    | '/settings/billing'
    | '/settings/employment-categories'
    | '/shifts/$shiftId'
    | '/clients/$clientId/sites/new'
    | '/documents/invoice/$clientId/$invoiceId'
    | '/documents/payslip/$accountId/$runId'
    | '/payroll/runs/$runId'
    | '/clients/$clientId/sites/$siteId/memo-book'
    | '/clients/$clientId/sites/$siteId'
    | '/payroll/runs/$runId/employees/$userId'
  id:
    | '__root__'
    | '/'
    | '/EmptyPage'
    | '/(auth)/check-email'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/resend-verification'
    | '/(auth)/reset-password'
    | '/(auth)/signup'
    | '/(auth)/verify-email'
    | '/chat/$conversationId'
    | '/incidents/$incidentId'
    | '/incidents/resolved'
    | '/invoices/$invoiceId'
    | '/onboarding/create-org'
    | '/settings/incident-visibility'
    | '/settings/notification-defaults'
    | '/access-profiles/'
    | '/activity/'
    | '/chat/'
    | '/clients/'
    | '/coverage-requests/'
    | '/dashboard/'
    | '/employees/'
    | '/incidents/'
    | '/invoices/'
    | '/live-map/'
    | '/organisation/'
    | '/payroll/'
    | '/profile/'
    | '/scheduler/'
    | '/settings/'
    | '/chat/broadcasts/$broadcastId'
    | '/chat/broadcasts/new'
    | '/employees/$employeeId/profile'
    | '/invitations/$id/accept'
    | '/onboarding/setup/$accountId'
    | '/access-profiles/$profileId/'
    | '/chat/broadcasts/'
    | '/clients/$clientId/'
    | '/patrols/$patrolId/'
    | '/scheduler/attendance/'
    | '/scheduler/office-time/'
    | '/scheduler/overtime/'
    | '/scheduler/site-roster/'
    | '/scheduler/templates/'
    | '/scheduler/time-off/'
    | '/settings/billing/'
    | '/settings/employment-categories/'
    | '/shifts/$shiftId/'
    | '/clients/$clientId/sites/new'
    | '/documents/invoice/$clientId/$invoiceId'
    | '/documents/payslip/$accountId/$runId'
    | '/payroll/runs/$runId/'
    | '/clients/$clientId/sites/$siteId/memo-book'
    | '/clients/$clientId/sites/$siteId/'
    | '/payroll/runs/$runId/employees/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EmptyPageRoute: typeof EmptyPageRoute
  authCheckEmailRoute: typeof authCheckEmailRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authResendVerificationRoute: typeof authResendVerificationRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignupRoute: typeof authSignupRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  ChatConversationIdRoute: typeof ChatConversationIdRoute
  IncidentsIncidentIdRoute: typeof IncidentsIncidentIdRoute
  IncidentsResolvedRoute: typeof IncidentsResolvedRoute
  InvoicesInvoiceIdRoute: typeof InvoicesInvoiceIdRoute
  OnboardingCreateOrgRoute: typeof OnboardingCreateOrgRoute
  SettingsIncidentVisibilityRoute: typeof SettingsIncidentVisibilityRoute
  SettingsNotificationDefaultsRoute: typeof SettingsNotificationDefaultsRoute
  AccessProfilesIndexRoute: typeof AccessProfilesIndexRoute
  ActivityIndexRoute: typeof ActivityIndexRoute
  ChatIndexRoute: typeof ChatIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  CoverageRequestsIndexRoute: typeof CoverageRequestsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  EmployeesIndexRoute: typeof EmployeesIndexRoute
  IncidentsIndexRoute: typeof IncidentsIndexRoute
  InvoicesIndexRoute: typeof InvoicesIndexRoute
  LiveMapIndexRoute: typeof LiveMapIndexRoute
  OrganisationIndexRoute: typeof OrganisationIndexRoute
  PayrollIndexRoute: typeof PayrollIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  SchedulerIndexRoute: typeof SchedulerIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  ChatBroadcastsBroadcastIdRoute: typeof ChatBroadcastsBroadcastIdRoute
  ChatBroadcastsNewRoute: typeof ChatBroadcastsNewRoute
  EmployeesEmployeeIdProfileRoute: typeof EmployeesEmployeeIdProfileRoute
  InvitationsIdAcceptRoute: typeof InvitationsIdAcceptRoute
  OnboardingSetupAccountIdRoute: typeof OnboardingSetupAccountIdRoute
  AccessProfilesProfileIdIndexRoute: typeof AccessProfilesProfileIdIndexRoute
  ChatBroadcastsIndexRoute: typeof ChatBroadcastsIndexRoute
  ClientsClientIdIndexRoute: typeof ClientsClientIdIndexRoute
  PatrolsPatrolIdIndexRoute: typeof PatrolsPatrolIdIndexRoute
  SchedulerAttendanceIndexRoute: typeof SchedulerAttendanceIndexRoute
  SchedulerOfficeTimeIndexRoute: typeof SchedulerOfficeTimeIndexRoute
  SchedulerOvertimeIndexRoute: typeof SchedulerOvertimeIndexRoute
  SchedulerSiteRosterIndexRoute: typeof SchedulerSiteRosterIndexRoute
  SchedulerTemplatesIndexRoute: typeof SchedulerTemplatesIndexRoute
  SchedulerTimeOffIndexRoute: typeof SchedulerTimeOffIndexRoute
  SettingsBillingIndexRoute: typeof SettingsBillingIndexRoute
  SettingsEmploymentCategoriesIndexRoute: typeof SettingsEmploymentCategoriesIndexRoute
  ShiftsShiftIdIndexRoute: typeof ShiftsShiftIdIndexRoute
  ClientsClientIdSitesNewRoute: typeof ClientsClientIdSitesNewRoute
  DocumentsInvoiceClientIdInvoiceIdRoute: typeof DocumentsInvoiceClientIdInvoiceIdRoute
  DocumentsPayslipAccountIdRunIdRoute: typeof DocumentsPayslipAccountIdRunIdRoute
  PayrollRunsRunIdIndexRoute: typeof PayrollRunsRunIdIndexRoute
  ClientsClientIdSitesSiteIdMemoBookRoute: typeof ClientsClientIdSitesSiteIdMemoBookRoute
  ClientsClientIdSitesSiteIdIndexRoute: typeof ClientsClientIdSitesSiteIdIndexRoute
  PayrollRunsRunIdEmployeesUserIdIndexRoute: typeof PayrollRunsRunIdEmployeesUserIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/EmptyPage': {
      id: '/EmptyPage'
      path: '/EmptyPage'
      fullPath: '/EmptyPage'
      preLoaderRoute: typeof EmptyPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler/': {
      id: '/scheduler/'
      path: '/scheduler'
      fullPath: '/scheduler'
      preLoaderRoute: typeof SchedulerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payroll/': {
      id: '/payroll/'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof PayrollIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisation/': {
      id: '/organisation/'
      path: '/organisation'
      fullPath: '/organisation'
      preLoaderRoute: typeof OrganisationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live-map/': {
      id: '/live-map/'
      path: '/live-map'
      fullPath: '/live-map'
      preLoaderRoute: typeof LiveMapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/': {
      id: '/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/incidents/': {
      id: '/incidents/'
      path: '/incidents'
      fullPath: '/incidents'
      preLoaderRoute: typeof IncidentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/': {
      id: '/employees/'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof EmployeesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coverage-requests/': {
      id: '/coverage-requests/'
      path: '/coverage-requests'
      fullPath: '/coverage-requests'
      preLoaderRoute: typeof CoverageRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/': {
      id: '/chat/'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity/': {
      id: '/activity/'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-profiles/': {
      id: '/access-profiles/'
      path: '/access-profiles'
      fullPath: '/access-profiles'
      preLoaderRoute: typeof AccessProfilesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notification-defaults': {
      id: '/settings/notification-defaults'
      path: '/settings/notification-defaults'
      fullPath: '/settings/notification-defaults'
      preLoaderRoute: typeof SettingsNotificationDefaultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/incident-visibility': {
      id: '/settings/incident-visibility'
      path: '/settings/incident-visibility'
      fullPath: '/settings/incident-visibility'
      preLoaderRoute: typeof SettingsIncidentVisibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/create-org': {
      id: '/onboarding/create-org'
      path: '/onboarding/create-org'
      fullPath: '/onboarding/create-org'
      preLoaderRoute: typeof OnboardingCreateOrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/$invoiceId': {
      id: '/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof InvoicesInvoiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/incidents/resolved': {
      id: '/incidents/resolved'
      path: '/incidents/resolved'
      fullPath: '/incidents/resolved'
      preLoaderRoute: typeof IncidentsResolvedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/incidents/$incidentId': {
      id: '/incidents/$incidentId'
      path: '/incidents/$incidentId'
      fullPath: '/incidents/$incidentId'
      preLoaderRoute: typeof IncidentsIncidentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$conversationId': {
      id: '/chat/$conversationId'
      path: '/chat/$conversationId'
      fullPath: '/chat/$conversationId'
      preLoaderRoute: typeof ChatConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/signup': {
      id: '/(auth)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof authSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/resend-verification': {
      id: '/(auth)/resend-verification'
      path: '/resend-verification'
      fullPath: '/resend-verification'
      preLoaderRoute: typeof authResendVerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/check-email': {
      id: '/(auth)/check-email'
      path: '/check-email'
      fullPath: '/check-email'
      preLoaderRoute: typeof authCheckEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shifts/$shiftId/': {
      id: '/shifts/$shiftId/'
      path: '/shifts/$shiftId'
      fullPath: '/shifts/$shiftId'
      preLoaderRoute: typeof ShiftsShiftIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/employment-categories/': {
      id: '/settings/employment-categories/'
      path: '/settings/employment-categories'
      fullPath: '/settings/employment-categories'
      preLoaderRoute: typeof SettingsEmploymentCategoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/billing/': {
      id: '/settings/billing/'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler/time-off/': {
      id: '/scheduler/time-off/'
      path: '/scheduler/time-off'
      fullPath: '/scheduler/time-off'
      preLoaderRoute: typeof SchedulerTimeOffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler/templates/': {
      id: '/scheduler/templates/'
      path: '/scheduler/templates'
      fullPath: '/scheduler/templates'
      preLoaderRoute: typeof SchedulerTemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler/site-roster/': {
      id: '/scheduler/site-roster/'
      path: '/scheduler/site-roster'
      fullPath: '/scheduler/site-roster'
      preLoaderRoute: typeof SchedulerSiteRosterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler/overtime/': {
      id: '/scheduler/overtime/'
      path: '/scheduler/overtime'
      fullPath: '/scheduler/overtime'
      preLoaderRoute: typeof SchedulerOvertimeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler/office-time/': {
      id: '/scheduler/office-time/'
      path: '/scheduler/office-time'
      fullPath: '/scheduler/office-time'
      preLoaderRoute: typeof SchedulerOfficeTimeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scheduler/attendance/': {
      id: '/scheduler/attendance/'
      path: '/scheduler/attendance'
      fullPath: '/scheduler/attendance'
      preLoaderRoute: typeof SchedulerAttendanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patrols/$patrolId/': {
      id: '/patrols/$patrolId/'
      path: '/patrols/$patrolId'
      fullPath: '/patrols/$patrolId'
      preLoaderRoute: typeof PatrolsPatrolIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId/': {
      id: '/clients/$clientId/'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/broadcasts/': {
      id: '/chat/broadcasts/'
      path: '/chat/broadcasts'
      fullPath: '/chat/broadcasts'
      preLoaderRoute: typeof ChatBroadcastsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-profiles/$profileId/': {
      id: '/access-profiles/$profileId/'
      path: '/access-profiles/$profileId'
      fullPath: '/access-profiles/$profileId'
      preLoaderRoute: typeof AccessProfilesProfileIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/setup/$accountId': {
      id: '/onboarding/setup/$accountId'
      path: '/onboarding/setup/$accountId'
      fullPath: '/onboarding/setup/$accountId'
      preLoaderRoute: typeof OnboardingSetupAccountIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/$id/accept': {
      id: '/invitations/$id/accept'
      path: '/invitations/$id/accept'
      fullPath: '/invitations/$id/accept'
      preLoaderRoute: typeof InvitationsIdAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/$employeeId/profile': {
      id: '/employees/$employeeId/profile'
      path: '/employees/$employeeId/profile'
      fullPath: '/employees/$employeeId/profile'
      preLoaderRoute: typeof EmployeesEmployeeIdProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/broadcasts/new': {
      id: '/chat/broadcasts/new'
      path: '/chat/broadcasts/new'
      fullPath: '/chat/broadcasts/new'
      preLoaderRoute: typeof ChatBroadcastsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/broadcasts/$broadcastId': {
      id: '/chat/broadcasts/$broadcastId'
      path: '/chat/broadcasts/$broadcastId'
      fullPath: '/chat/broadcasts/$broadcastId'
      preLoaderRoute: typeof ChatBroadcastsBroadcastIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payroll/runs/$runId/': {
      id: '/payroll/runs/$runId/'
      path: '/payroll/runs/$runId'
      fullPath: '/payroll/runs/$runId'
      preLoaderRoute: typeof PayrollRunsRunIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/payslip/$accountId/$runId': {
      id: '/documents/payslip/$accountId/$runId'
      path: '/documents/payslip/$accountId/$runId'
      fullPath: '/documents/payslip/$accountId/$runId'
      preLoaderRoute: typeof DocumentsPayslipAccountIdRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/invoice/$clientId/$invoiceId': {
      id: '/documents/invoice/$clientId/$invoiceId'
      path: '/documents/invoice/$clientId/$invoiceId'
      fullPath: '/documents/invoice/$clientId/$invoiceId'
      preLoaderRoute: typeof DocumentsInvoiceClientIdInvoiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId/sites/new': {
      id: '/clients/$clientId/sites/new'
      path: '/clients/$clientId/sites/new'
      fullPath: '/clients/$clientId/sites/new'
      preLoaderRoute: typeof ClientsClientIdSitesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId/sites/$siteId/': {
      id: '/clients/$clientId/sites/$siteId/'
      path: '/clients/$clientId/sites/$siteId'
      fullPath: '/clients/$clientId/sites/$siteId'
      preLoaderRoute: typeof ClientsClientIdSitesSiteIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId/sites/$siteId/memo-book': {
      id: '/clients/$clientId/sites/$siteId/memo-book'
      path: '/clients/$clientId/sites/$siteId/memo-book'
      fullPath: '/clients/$clientId/sites/$siteId/memo-book'
      preLoaderRoute: typeof ClientsClientIdSitesSiteIdMemoBookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payroll/runs/$runId/employees/$userId/': {
      id: '/payroll/runs/$runId/employees/$userId/'
      path: '/payroll/runs/$runId/employees/$userId'
      fullPath: '/payroll/runs/$runId/employees/$userId'
      preLoaderRoute: typeof PayrollRunsRunIdEmployeesUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EmptyPageRoute: EmptyPageRoute,
  authCheckEmailRoute: authCheckEmailRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authResendVerificationRoute: authResendVerificationRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignupRoute: authSignupRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  ChatConversationIdRoute: ChatConversationIdRoute,
  IncidentsIncidentIdRoute: IncidentsIncidentIdRoute,
  IncidentsResolvedRoute: IncidentsResolvedRoute,
  InvoicesInvoiceIdRoute: InvoicesInvoiceIdRoute,
  OnboardingCreateOrgRoute: OnboardingCreateOrgRoute,
  SettingsIncidentVisibilityRoute: SettingsIncidentVisibilityRoute,
  SettingsNotificationDefaultsRoute: SettingsNotificationDefaultsRoute,
  AccessProfilesIndexRoute: AccessProfilesIndexRoute,
  ActivityIndexRoute: ActivityIndexRoute,
  ChatIndexRoute: ChatIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  CoverageRequestsIndexRoute: CoverageRequestsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  EmployeesIndexRoute: EmployeesIndexRoute,
  IncidentsIndexRoute: IncidentsIndexRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
  LiveMapIndexRoute: LiveMapIndexRoute,
  OrganisationIndexRoute: OrganisationIndexRoute,
  PayrollIndexRoute: PayrollIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  SchedulerIndexRoute: SchedulerIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  ChatBroadcastsBroadcastIdRoute: ChatBroadcastsBroadcastIdRoute,
  ChatBroadcastsNewRoute: ChatBroadcastsNewRoute,
  EmployeesEmployeeIdProfileRoute: EmployeesEmployeeIdProfileRoute,
  InvitationsIdAcceptRoute: InvitationsIdAcceptRoute,
  OnboardingSetupAccountIdRoute: OnboardingSetupAccountIdRoute,
  AccessProfilesProfileIdIndexRoute: AccessProfilesProfileIdIndexRoute,
  ChatBroadcastsIndexRoute: ChatBroadcastsIndexRoute,
  ClientsClientIdIndexRoute: ClientsClientIdIndexRoute,
  PatrolsPatrolIdIndexRoute: PatrolsPatrolIdIndexRoute,
  SchedulerAttendanceIndexRoute: SchedulerAttendanceIndexRoute,
  SchedulerOfficeTimeIndexRoute: SchedulerOfficeTimeIndexRoute,
  SchedulerOvertimeIndexRoute: SchedulerOvertimeIndexRoute,
  SchedulerSiteRosterIndexRoute: SchedulerSiteRosterIndexRoute,
  SchedulerTemplatesIndexRoute: SchedulerTemplatesIndexRoute,
  SchedulerTimeOffIndexRoute: SchedulerTimeOffIndexRoute,
  SettingsBillingIndexRoute: SettingsBillingIndexRoute,
  SettingsEmploymentCategoriesIndexRoute:
    SettingsEmploymentCategoriesIndexRoute,
  ShiftsShiftIdIndexRoute: ShiftsShiftIdIndexRoute,
  ClientsClientIdSitesNewRoute: ClientsClientIdSitesNewRoute,
  DocumentsInvoiceClientIdInvoiceIdRoute:
    DocumentsInvoiceClientIdInvoiceIdRoute,
  DocumentsPayslipAccountIdRunIdRoute: DocumentsPayslipAccountIdRunIdRoute,
  PayrollRunsRunIdIndexRoute: PayrollRunsRunIdIndexRoute,
  ClientsClientIdSitesSiteIdMemoBookRoute:
    ClientsClientIdSitesSiteIdMemoBookRoute,
  ClientsClientIdSitesSiteIdIndexRoute: ClientsClientIdSitesSiteIdIndexRoute,
  PayrollRunsRunIdEmployeesUserIdIndexRoute:
    PayrollRunsRunIdEmployeesUserIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
